import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BoschUiStickerType } from './bosch-ui-sticker.model';
import { getRandomId } from '../../utils/get-random-id';

@Component({
  selector: 'bosch-ui-sticker',
  imports: [CommonModule],
  templateUrl: './bosch-ui-sticker.component.html',
  styleUrls: ['./bosch-ui-sticker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoschUiStickerComponent {
  @Input() color: BoschUiStickerType = 'primary';
  readonly id: string = getRandomId('sticker');
}
